import React from 'react';

const NotFound = (props) => {
  return <h2>oops!</h2>;
};

export default NotFound;
